import {
  byWindowAction, debounce,
} from '@html/_common/utils';

export default function AOCarouselSlider() {
  const SELECTOR_SLIDER = '.js-ao-clp-carousel-slider__slider';
  const SELECT_ARROW_LEFT = '.js-ao-clp-carousel-slider__arrow--left';
  const SELECT_ARROW_RIGHT = '.js-ao-clp-carousel-slider__arrow--right';
  const SELECTOR_DOTS = '.js-ao-clp-carousel-slider__dots';
  const CLASS_ACTIVE_DOT = 'ao-clp-carousel-slider__dots-dot--active';

  const carousels = [];

  let $carousels;

  this.initiate = () => {
    $carousels = $(SELECTOR_SLIDER);

    if (!$carousels.length) {
      return;
    }

    $carousels.each(this.initiateCarousel);

    byWindowAction(['resize'], this.onResize);
  };

  this.initiateCarousel = (index, element) => {
    const $carouselElement = $(element);

    const carouselId = carousels.length;
    const carousel = {};
    carousel.index = 0;
    carousel.shown = 1;
    carousel.total = $carouselElement.children().length;
    carousel.elementMargin = 0;
    carousel.$listElement = $carouselElement;
    carousel.$firstElement = $carouselElement.children().first();
    carousel.$arrowElements = $carouselElement.parent().find('.js-ao-clp-carousel-slider__arrow');
    carousel.$dots = $carouselElement.parent().find(SELECTOR_DOTS);
    carousel.EVENT_CATEGORY = $carouselElement.data('event-category');
    carousel.EVENT_LABEL = $carouselElement.data('event-label');

    $carouselElement.data('carouselId', carouselId);

    this.calculateElementDimensions(carousel);

    carousel.$arrowElements.each((arrowIndex, arrowElement) => {
      const $arrowElement = $(arrowElement);
      $arrowElement.data('carouselId', carouselId);
      $arrowElement.off('click').on('click', this.onClickArrow);
    });

    this.calculateShown(carousel);
    this.checkArrowActivity(carousel);
    this.calculateDots(carousel);

    carousels.push(carousel);
  };

  this.calculateElementDimensions = (carousel) => {
    // eslint-disable-next-line no-param-reassign
    carousel.elementWidth = carousel.$firstElement.width();
  };

  this.calculateShown = (carousel) => {
    const newShown = Math.round(carousel.$listElement.width() / carousel.elementWidth);

    // eslint-disable-next-line no-param-reassign
    carousel.index = Math.floor((carousel.shown * carousel.index) / newShown);
    // eslint-disable-next-line no-param-reassign
    carousel.shown = newShown;
  };

  this.checkArrowActivity = (carousel) => {
    const isFirstCarouselItem = carousel.index === 0;
    const isLastCarouselItem = ((carousel.index * carousel.shown) + carousel.shown) >= carousel.total;

    const arrowLeft = carousel.$arrowElements.filter(SELECT_ARROW_LEFT);
    const arrowRight = carousel.$arrowElements.filter(SELECT_ARROW_RIGHT);

    arrowLeft.prop('disabled', isFirstCarouselItem);
    arrowRight.prop('disabled', isLastCarouselItem);

    const arrowsDisabled = arrowLeft.prop('disabled') && arrowRight.prop('disabled');

    arrowLeft.toggleClass('hid', (carousel.total <= carousel.shown || arrowsDisabled));
    arrowRight.toggleClass('hid', (carousel.total <= carousel.shown || arrowsDisabled));
  };

  this.onClickArrow = (event) => {
    const $arrow = $(event.currentTarget);
    const carouselId = $arrow.data('carouselId');
    const carousel = carousels[carouselId];
    const arrowDirection = $arrow.hasClass('js-ao-clp-carousel-slider__arrow--right') ? 'right' : 'left';

    if (arrowDirection === 'right') {
      carousel.index += 1;
    } else {
      carousel.index -= 1;
    }

    this.moveCarousel(carousel);
    this.checkArrowActivity(carousel);
    this.checkDotsActivity(carousel);
  };

  this.moveCarousel = (carousel) => {
    let margin = -(carousel.index * carousel.shown
            * (carousel.elementWidth + carousel.elementMargin));
    const currentMargin = parseInt(carousel.$firstElement.css('margin-left'), 10);

    if (margin <= currentMargin) {
      const maxMargin = -((carousel.total - carousel.shown)
                * (carousel.elementWidth + carousel.elementMargin));
      margin = Math.max(margin, maxMargin);
    } else {
      margin = Math.min(margin, 0);
    }

    carousel.$firstElement.css('margin-left', margin);
  };

  this.moveToStart = (carousel) => {
    carousel.$firstElement.css('margin-left', 0);
    // eslint-disable-next-line no-param-reassign
    carousel.index = 0;
  };

  this.calculateDots = (carousel) => {
    carousel.$dots.html('');
    const numOfDots = Math.ceil(carousel.total / carousel.shown);

    if (!carousel.$dots.length || numOfDots < 2) {
      return;
    }

    for (let i = 0; i < numOfDots; i += 1) {
      carousel.$dots.append(`
      <li class="ao-clp-carousel-slider__dots-dot"></li>`);
    }

    carousel.$dots.removeClass('hid');
    this.checkDotsActivity(carousel);
  };

  this.checkDotsActivity = (carousel) => {
    const $activeDot = carousel.$dots.children().eq(carousel.index);
    $activeDot.addClass(CLASS_ACTIVE_DOT).siblings().removeClass(CLASS_ACTIVE_DOT);
  };

  this.onResize = debounce(() => {
    for (let i = 0; i < carousels.length; i += 1) {
      const carousel = carousels[i];

      this.calculateElementDimensions(carousel);
      this.calculateShown(carousel);
      this.moveToStart(carousel);
      this.checkArrowActivity(carousel);
      this.calculateDots(carousel);
    }
  }, 250);
}
